<template>
  <div class="home">
    <div class="swiper-box">
      <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in slideShow">
          <img :src="item.img" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- <div class="content">
      <van-dialog v-model="tcshow" title="公告" show-cancel-button>
        <p>关于gates网关年度例行休整的公告</p>
        <p style="text-indent: 2ch">
          亲爱的网关LQD共识伙伴，感恩大家的相信与坚持，努力与付出，使我们在全球的共识份额取得骄人成绩!
          2025年是LQD共识推进的关键一年，为了更好的服务全球共识伙伴，为了更加扎实的推进共识进程，网关在人员，技术，数据等全方面进行年度例行休整。休整期间，希望所有伙伴务必严格遵守以下几点注意事项:
          1.休整时限内，APP只开放注册，登陆功能!
          2.关闭APP交易，释放，充值，提现等关键数据功能! 3.休整时限为:
          2025-01-23-00:00至2025-02-06-10:00 休整共计15天! 备注:
          1.在年度休整期间，可操作注册，登陆功能。禁止其他功能的操作，否则，因个人不当操作造成的损失，由个人自行承担!
          2.各位伙伴的收益，待休整期结束后，收益顺延，伙伴们的收益不会受到任何损失!
          感恩伙伴们积极的支持与配合!2025年度，我们与大家同在，共同携手并肩，加快推动共识进程，再创佳绩!
          gates网关全球事业部 2025年01月21日
        </p>
      </van-dialog>
    </div> -->

    <!-- 通知栏 -->
    <div class="noticeBox">
      <van-notice-bar
        scrollable
        left-icon="volume-o"
        :text="announcement.excerpt"
      >
        <template>
          <span @click="goLink('/noticeDetails', announcement)">
            {{ announcement.excerpt }}
          </span>
          <template> </template>
        </template>
        <!-- @click="goLink('/m_index/home/noticeDetails')" -->
        <template #right-icon>
          <van-icon name="bars" size="20" @click="goLink('/Notice')" />
        </template>
      </van-notice-bar>
    </div>
    <div class="header">
      <ul>
        <li v-for="item in listHome" :key="item.id" @click="goLink(item.path)">
          <img :src="item.url" />
          <p class="fn-13">{{ item.txt }}</p>
        </li>
      </ul>
    </div>

    <!-- 全网数据 -->
    <div class="NetWideData">
      <div class="NetWideData_p" style="margin: 0px 15px 0px 15px">
        <span>全网数据</span>
        <!-- <img src="../../assets/img/page/hx.png" /> -->
      </div>
      <div class="swiper_txt">
        <div class="swiper_img">
          <!-- <img src="../../assets/img/page/_3.gif" /> -->
          <div class="swiper_img_box">
            {{ items[currentIndex].valStr }}
          </div>
          <span>{{ items[currentIndex].title }}</span>
        </div>
        <div class="swiper_data">
          <van-swipe
            class="scroll-container"
            :autoplay="autoplayInterval"
            :interval="interval"
            :show-indicators="false"
            @change="handleChange"
          >
            <van-swipe-item>
              <div class="scroll-content" ref="scrollContent">
                <div
                  v-for="(item, index) in items"
                  :key="index"
                  style="padding: 5px 0"
                  @click="currentIndex = index"
                >
                  <div class="scroll-item">
                    <span :class="{ active: currentIndex === index }"
                      >{{ item.title }}
                    </span>
                    <span
                      style="padding-left: 10px"
                      :class="{ actives: currentIndex === index }"
                      >{{ item.valStr }}
                    </span>
                  </div>
                </div>
                <!-- <van-row class="scroll-row" :gutter="0">
                  <van-col
                    v-for="(item, index) in items"
                    :key="index"
                    style="padding: 5px 0"
                    @click="currentIndex = index"
                  >
                    <div class="scroll-item">
                      <span :class="{ active: currentIndex === index }"
                        >{{ item.title }}
                      </span>
                      <span
                        style="padding-left: 10px"
                        :class="{ actives: currentIndex === index }"
                        >{{ item.valStr }}
                      </span>
                    </div>
                  </van-col>
                </van-row> -->
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>

    <Tabbar :active="0"></Tabbar>
  </div>
</template>
<script>
import Vue from "vue";
// import { NoticeBar } from "vant";
import { NoticeBar, Col, Row } from "vant";
Vue.use(NoticeBar).use(Col).use(Row);

Vue.use(NoticeBar);
import axios from "axios";
import NumberGrow from "./test.vue";
import { mainApiData } from "@/request/api.js";
export default {
  components: {
    NumberGrow,
  },
  data() {
    return {
      tcshow: true,
      // 数据项
      items: [
        {
          title: "最新区块高度",
          valStr: 0,
        },
        {
          title: "近24H增长算力",
          valStr: 0,
        },
        {
          title: "全网有效算力",
          valStr: 0,
        },
        {
          title: "近24h出块奖励",
          valStr: 0,
        },
        {
          title: "当前基础费率",
          valStr: 0,
        },
        {
          title: "全网出块奖励",
          valStr: 0,
        },
        {
          title: "活跃矿工",
          valStr: 0,
        },
      ],
      // 当前高亮项的索引
      currentIndex: 0,
      // 可见项的数量
      visibleItemCount: 6,
      // 自动滚动间隔时间（单位：毫秒）
      autoplayInterval: 3000,
      // 滚动动画时间（单位：毫秒）
      interval: 3000,
      // 定时器的 ID
      scrollInterval: null,

      baseApi: "",
      listHome: [
        {
          url: require("../../assets/img/page/QB-52.png"),
          txt: "钱包",
          id: 0,
          path: "/My/assets",
        },
        {
          url: require("../../assets/img/page/SD-52.png"),
          txt: "闪兑",
          id: 1,
          path: "/My/flashExchange",
        },
        {
          url: require("../../assets/img/page/RG-52.png"),
          txt: "认购",
          id: 2,
          path: "/subscription",
        },
        {
          url: require("../../assets/img/page/KJ-52.png"),
          txt: "矿机",
          id: 3,
        },
      ],
      slideShow: [
        // {
        // 	img: require('../../assets/img/page/1.png')
        // },

        {
          img: require("../../assets/img/page/2.png"),
        },
        {
          img: require("../../assets/img/page/3.png"),
        },
        {
          img: require("../../assets/img/page/banner-345x160.png"),
        },
      ],
      ListVla: [],
      announcement: {
        content: "",
      },
      ClearTimeInit: "",
      allNetData: [],
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.Init();
    if(localStorage.getItem("tcshow")){
      this.tcshow = false;
    }else{
      this.tcshow = true;
    }
  },
  mounted() {
    // 计算可见项的数量
    this.visibleItemCount = Math.min(this.items.length, 6);
    // 开始自动滚动
    this.startAutoScroll();
    // ClearTimeInit
    this.TimeInit();
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.scrollInterval);
  },
  methods: {
    closeTcshow()
    {
      localStorage.setItem('tcshow',false)
    },
    // 开始自动滚动
    startAutoScroll() {
      // 获取容器的高度
      const scrollHeight = this.$refs.scrollContent.offsetHeight;
      // 计算每个项的高度
      const itemHeight = scrollHeight / this.items.length;
      // 设置定时器，定时滚动
      this.scrollInterval = setInterval(() => {
        // 计算下一个高亮项的索引
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        // 设置容器的 scrollTop，使其滚动到下一个项的位置
        this.$refs.scrollContent.scrollTop = this.currentIndex * itemHeight;
      }, this.interval);
    },
    // 处理切换事件
    handleChange(index) {
      // 更新当前高亮项的索引
      this.currentIndex = index;
    },
    TimeInit() {
      //     axios.post('https://api-v2.filscan.io:27000/api/v1/TotalIndicators', {
      // 	"id": 1,
      // 	"jsonrpc": "2.0",
      // 	"params": [],
      // 	"method": "filscan.StatChainInfo"
      // })
      // 	.then(response => {
      // 		console.log(response.result.data);
      // 		// this.ListVla = response.total_indicators;
      //     this.items[0].Num=response.total_indicators.latest_height;
      //     this.items[1].Num=response.total_indicators.latest_height;
      //     this.items[2].Num=response.total_indicators.latest_height;
      //     this.items[3].Num=response.total_indicators.latest_height;
      //     this.items[4].Num=response.total_indicators.latest_height;
      //     this.items[5].Num=response.total_indicators.latest_height;
      // 	});
    },

    Init() {
      // axios.post('https://api.filscan.io:8700/rpc/v1', {
      // 	"id": 1,
      // 	"jsonrpc": "2.0",
      // 	"params": [],
      // 	"method": "filscan.StatChainInfo"
      // })
      // 	.then(response => {
      // 		console.log(response.result.data);
      // 		this.ListVla = response.result.data;
      // 	});
      mainApiData.getLastArticles().then((res) => {
        this.announcement = res.data.data;
      });
      mainApiData.getHomeInfo().then((res) => {
        console.log(res);
        this.items = res.data.data;
      });
    },
    goLink(path, item) {
      if (path) {
        this.$router.push({
          path,
          query: {
            item: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
.content {
  ::v-deep .van-dialog__content {
    font-size: 14px !important;
    padding: 0px 10px;
    color: #fff;
  }
  ::v-deep .van-button--default {
    background: transparent;
    border: 0;
  }
}

::v-deep .active {
  color: #ffffff;
  font-size: 12px;
}
::v-deep .actives {
  color: #f89b19;
  font-size: 12px;
}

// ::v-deep .scroll-container {
//   height: 300px;  border:1px solid red;
//   line-height: 20px;
// }

::v-deep .scroll-content {
  // height: 100%;
  // overflow: hidden;
  // width: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  // border: solid 1px red;
}

::v-deep .scroll-row {
  height: 100%;
}

::v-deep .scroll-item {
  height: calc(100% / 7);
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  // border:1px solid red;
  // color: #333;
}

::v-deep .scroll-row {
  display: flex;
  flex-direction: column;
  // justify-content: flex-start;
  // align-items: flex-start;
}
.home {
  .header {
    margin: 20px 0;

    ul {
      display: grid;
      justify-content: space-between;
      grid-template-columns: 25% 25% 25% 25%;
      text-align: center;

      li {
        p {
          padding: 10px 0;
          color: #fff;
        }
        img {
          width: 60px;
          height: 60px;
        }
      }

      // align-items: center;
    }
  }

  // 轮播图
  .swiper-box {
    padding: 0 15px;
    width: 100%;
    height: 175px;
    overflow: hidden;
    margin-top: 20px;

    // border: 1px solid red;
    .my-swipe {
      height: 100%;
      width: 100%;
      margin: 0 auto;

      // border: 1px solid #FFD13E;
      // border-radius: 14px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        // border-radius: 13px;
        // border: 1px solid red;
        margin: 0 auto;
      }
    }

    .van-swipe {
      overflow: hidden;
    }
  }

  // 公告
  .noticeBox {
    margin: 15px;
    // padding: 12px;
    // background-color: #2C303C;
    // border: 0.0625rem solid #FFC27E;
    box-shadow: 0 0 0 0.5px #f89b19;
    color: #8a929d;
    border-radius: 4px 4px 4px 4px;

    ::v-deep .van-notice-bar {
      border-radius: 4px 4px 4px 4px;
      color: #f89b19;
      background: transparent;
    }

    img {
      width: 18px;
      height: 17px;
    }

    .noticeBtn {
      padding: 3px 20px;
      margin: 0 15px;
      background: #f89b19;
      border-radius: 4px 4px 4px 4px;
      font-weight: 500;
      color: #f89b19;
    }
  }

  // 全网数据
  .NetWideData {
    margin: 20px 0px 0px 0px;
    padding-bottom: 100px;
    .swiper_txt {
      // border: solid red 1px;
      padding: 10px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      .swiper_img {
        flex: 1;
        display: flex;
        // align-items: center;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .swiper_img_box {
          width: 184px;
          height: 184px;
          background: url(../../assets/img/page/Frame_458@2x.png) no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #f89b19;
          font-size: 18px;
        }

        span {
          margin-top: 10px;
          font-size: 16px;
          color: rgba(254, 254, 254, 1);
        }
      }
      .swiper_data {
        flex: 1;
        // padding: 10px;
        // display: flex;
        // align-items: center;
        // justify-content: flex-start;
        // border: solid 1px blue;
        // padding: 0;
      }
    }
    .NetWideData_p {
      span {
        // background: url("../../assets/img/page/bj3.png") no-repeat scroll;
        background-size: 100% 100%;
        background-position: center center;
        color: #fff;
        // padding: 5px 10px;
        font-size: 16px;
        color: #f89b19;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .txt {
      // width: 50%;
      margin: 20px 0;

      span {
        &:nth-child(1) {
          text-align: center;
          display: block;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          // flex-direction: column;
        }

        font-family: "LcdD";
        font-style: italic;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        /* identical to box height */
        color: #b5b5b5;

        // text-align: center;
        &:nth-child(2) {
          text-align: center;
          margin-right: 80px;

          display: block;
        }
      }
    }
  }
}
</style>
